import React from 'react'
import { useLocation } from 'react-router-dom'
import ReinvestRegA from './RegA'

const Reinvest = () => {
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const regulation = searchParams.get('regulation')

  const renderReinvestFlow = () => {
    switch (regulation) {
      case 'reg-a':
        return <ReinvestRegA />

      default:
        return <ReinvestRegA />
    }
  }

  return <div>{renderReinvestFlow()}</div>
}

export default Reinvest
